var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"text-center text-lighter font-weight-normal mt-5 mb-0"},[_vm._v("Login to Shared Intranet Account")]),_c('form',{staticClass:"my-5"},[(_vm.errors.common)?_c('b-form-group',{staticClass:"mb-0"},[_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.common))])]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }